<template>
  <!-- ******************* -->
  <!-- *      Modal      * -->
  <!-- ******************* -->
  <!-- This modal is for editing or creating projects -->
  <div
    class="modal fade"
    id="editProjectDialog"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <form id="editProjectForm">
          <div class="modal-header">
            <!-- Close button in the upper right corner -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>

            <!-- Modal Title -->
            <h4 class="modal-title">
              <b>{{ dialogTitle }}</b>
            </h4>

            <!-- History Icon  -->
            <div v-if="projectData.ProjectId">
              <label class="control-label"
                >ID: {{ projectData.ProjectId }}</label
              >
              <i
                id="showProjectHistoryInfoIcon"
                class="material-icons md-24"
                @click="showProjectHistory()"
                >history</i
              >
              <b-tooltip
                ref="tooltip"
                target="showProjectHistoryInfoIcon"
                :delay="globals.tooltipDelay"
                >{{ lang.P1041 }}</b-tooltip
              >
            </div>
          </div>
          <div class="modal-body">
            <!-- Accordion - hides content that is not used -->
            <div
              class="panel-group"
              id="accordionEditProject"
              role="tablist"
              aria-multiselectable="true"
            >
              <div class="panel panel-default">
                <!-- Accordion entry 1 -->
                <div
                  class="panel-heading"
                  role="button"
                  id="headingEditProjectGeneral"
                  data-toggle="collapse"
                  data-parent="#accordionEditProject"
                  href="#collapseEditProjectGeneral"
                  aria-expanded="true"
                  aria-controls="collapseEditProjectGeneral"
                >
                  <h4 class="panel-title">
                    <a class="collapsed">{{ lang.P1000 }}</a>
                  </h4>
                </div>
                <div
                  id="collapseEditProjectGeneral"
                  class="panel-collapse collapse in"
                  role="tabpanel"
                  aria-labelledby="headingEditProjectGeneral"
                >
                  <div class="panel-body">
                    <!-- Add inputs here -->
                    <div class="form-group">
                      <label for="inputName" class="col-md-2 control-label"
                        >{{ lang.P1001 }}*</label
                      >
                      <div class="col-md-10">
                        <input
                          type="text"
                          class="form-control"
                          id="inputName"
                          name="inputName"
                          v-model="projectData.ProjectName"
                          @keyup="validateInput('inputName')"
                          required
                        />
                        <span
                          v-show="inputHasError('inputName')"
                          class="help-block error text-danger"
                          >{{ lang.P1002 }}</span
                        >
                      </div>
                    </div>
                    <div
                      class="form-group"
                      v-if="
                        !feature.isAudiTarget ||
                        !feature.isEnabled('audi_importers')
                      "
                    >
                      <label
                        for="editProjectClientSelect"
                        class="col-md-2 control-label"
                        >{{ lang.P1003 }}*</label
                      >
                      <div class="col-md-10">
                        <select2
                          id="editProjectClientSelect"
                          class="form-control"
                          :key="projectData.ClientId"
                          :dataTransformer="(data) => Number(data[0].id)"
                          :afterChange="getAvailableSurveysForClient"
                          v-model="projectData.ClientId"
                          :placeholder="lang.P1004"
                          :disabled="!dialogModeAdd"
                          required
                        >
                          <option
                            v-for="client in clientList"
                            :key="client.ClientId"
                            :value="parseInt(client.ClientId)"
                          >
                            {{ client.ClientName }}
                          </option>
                        </select2>
                        <span
                          v-show="inputHasError('editProjectClientSelect')"
                          class="help-block error text-danger"
                          >{{ lang.P1002 }}</span
                        >
                      </div>
                    </div>
                    <div class="form-group" v-else>
                      <label
                        for="editProjectImporterSelect"
                        class="col-md-2 control-label"
                        >{{ lang.P1036 }}*</label
                      >
                      <div class="col-md-10">
                        <select2
                          id="editProjectImporterSelect"
                          class="form-control"
                          v-model="projectData.ImporterGuid"
                          :placeholder="lang.P1004"
                          required
                        >
                          <option
                            v-for="importer in importerList"
                            :key="importer.ImporterGuid"
                            :value="importer.ImporterGuid"
                          >
                            {{ importer.ImporterName }}
                          </option>
                        </select2>
                        <span
                          v-show="inputHasError('editProjectImporterSelect')"
                          class="help-block error text-danger"
                          >{{ lang.P1002 }}</span
                        >
                      </div>
                    </div>
                    <div class="form-group" v-if="!feature.isAudiTarget">
                      <label
                        for="inputProjectAccountable"
                        class="col-md-2 control-label"
                        >{{ lang.P1022 }}*</label
                      >
                      <div class="col-md-10">
                        <select2
                          id="inputProjectAccountable"
                          class="form-control"
                          :key="projectData.ProjectAccountableGuid"
                          v-model="projectData.ProjectAccountableGuid"
                          :placeholder="lang.P1004"
                          required
                        >
                          <option
                            v-for="(
                              accountable, guid
                            ) in listOfProjectAccountables"
                            :key="guid"
                            :value="guid"
                          >
                            {{ accountable }}
                          </option>
                        </select2>
                        <span
                          v-show="inputHasError('inputProjectAccountable')"
                          class="help-block error text-danger"
                          >{{ lang.P1002 }}</span
                        >
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputProjectSince"
                        class="col-md-2 control-label"
                        >{{ lang.P1015 }}</label
                      >
                      <div
                        class="col-md-10"
                        @click="globals.toggleFlatpickr('inputProjectSince')"
                      >
                        <input
                          type="text"
                          class="form-control"
                          id="inputProjectSince"
                          name="inputProjectSince"
                          v-model="projectData.ProjectSince"
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputProjectUntil"
                        class="col-md-2 control-label"
                        >{{ lang.P1016 }}</label
                      >
                      <div
                        class="col-md-10"
                        @click="globals.toggleFlatpickr('inputProjectUntil')"
                      >
                        <input
                          type="text"
                          class="form-control"
                          id="inputProjectUntil"
                          name="inputProjectUntil"
                          v-model="projectData.ProjectUntil"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Accordion entry 2 -->
                <div
                  class="panel-heading"
                  role="button"
                  id="headingEditProjectSurveys"
                  data-toggle="collapse"
                  data-parent="#accordionEditProject"
                  href="#collapseEditProjectSurveys"
                  aria-expanded="false"
                  aria-controls="collapseEditProjectSurveys"
                >
                  <h4 class="panel-title">
                    <a class="collapsed">{{ lang.P1005 }}</a>
                  </h4>
                </div>
                <div
                  id="collapseEditProjectSurveys"
                  class="panel-collapse collapse"
                  role="tabpanel"
                  aria-labelledby="headingEditProjectSurveys"
                >
                  <div class="panel-body" style="padding: 15px">
                    <!-- Add inputs here -->
                    <div class="col-md-12">
                      <!-- Buttons for switching survey assignments -->
                      <a
                        role="button"
                        class="btn btn-fab btn-fab-mini dialog-btn-primary"
                        :disabled="selectedAssignedSurveyIds.length == 0"
                        @click="unassignSurveys()"
                      >
                        <i class="material-icons">arrow_back</i>
                      </a>
                      <a
                        id="assignSurveysButton"
                        role="button"
                        class="btn btn-fab btn-fab-mini dialog-btn-primary"
                        :disabled="selectedUnassignedSurveyIds.length == 0"
                        @click="assignSurveys()"
                      >
                        <i class="material-icons">arrow_forward</i>
                      </a>
                    </div>

                    <div class="col-md-6">
                      <!-- List with available surveys -->
                      <table
                        class="table table-striped table-hover"
                        id="availableSurveys"
                      >
                        <thead>
                          <tr>
                            <th class="text-center">{{ lang.P1006 }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            role="button"
                            v-for="survey in getUnassignedSurveys()"
                            :key="survey.SurveyId"
                            @click="
                              toggleListItem(
                                selectedUnassignedSurveyIds,
                                survey.SurveyId
                              )
                            "
                            @dblclick="
                              (selectedUnassignedSurveyIds = []),
                                toggleSurveyListItem(
                                  projectData.Surveys,
                                  survey.SurveyId
                                )
                            "
                            :class="{
                              info:
                                selectedUnassignedSurveyIds.indexOf(
                                  survey.SurveyId
                                ) > -1,
                            }"
                          >
                            <td>{{ survey.SurveyTitle }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="col-md-6">
                      <!-- List with assigned surveys -->
                      <table class="table table-striped table-hover">
                        <thead>
                          <tr>
                            <th class="text-center" style="width: 60%">
                              {{ lang.P1007 }}
                            </th>
                            <th class="text-center" style="width: 40%">
                              {{ lang.P1014 }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            role="button"
                            v-for="survey in getAssignedSurveys()"
                            :key="survey.SurveyId"
                            @click="
                              toggleListItem(
                                selectedAssignedSurveyIds,
                                survey.SurveyId
                              )
                            "
                            @dblclick="
                              (selectedAssignedSurveyIds = []),
                                toggleSurveyListItem(
                                  projectData.Surveys,
                                  survey.SurveyId
                                )
                            "
                            :class="{
                              info:
                                selectedAssignedSurveyIds.indexOf(
                                  survey.SurveyId
                                ) > -1,
                            }"
                          >
                            <td style="width: 60%">
                              {{ survey.SurveyTitle }}
                            </td>
                            <td style="width: 40%; padding: 5px">
                              <div class="checkbox" style="margin: 0px">
                                <label>
                                  <input
                                    type="checkbox"
                                    @change="
                                      surveyReportingVisibilityChanged(
                                        projectData.Surveys[
                                          getIndexOfSurveyInProjectDataSurveys(
                                            survey.SurveyId
                                          )
                                        ]
                                      )
                                    "
                                    v-model="
                                      projectData.Surveys[
                                        getIndexOfSurveyInProjectDataSurveys(
                                          survey.SurveyId
                                        )
                                      ].ReportingVisibility
                                    "
                                  />
                                  <span class="checkbox-material">
                                    <span class="check"></span>
                                  </span>
                                </label>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <!-- Accordion entry 3 -->
                <div
                  class="panel-heading"
                  role="button"
                  id="headingEditProjectFileUpload"
                  data-toggle="collapse"
                  data-parent="#accordionEditProject"
                  href="#collapseEditProjectDocuments"
                  aria-expanded="false"
                  aria-controls="collapseEditProjectDocuments"
                >
                  <h4 class="panel-title">
                    <a class="collapsed">{{ lang.P1023 }}</a>
                  </h4>
                </div>
                <div
                  id="collapseEditProjectDocuments"
                  class="panel-collapse collapse"
                  role="tabpanel"
                  aria-labelledby="headingEditProjectSurveys"
                >
                  <div class="panel-body" style="padding: 15px">
                    <!-- Add inputs here -->
                    <!-- briefings -->
                    <div class="col-md-6">
                      <div class="form-group form-group-files">
                        <label
                          for="inputBriefingAttachmentFile"
                          class="col-md-2 control-label"
                          >{{ lang.P1024 }}</label
                        >
                        <div class="col-md-8">
                          <input
                            id="inputBriefingAttachmentFile"
                            class="form-control"
                            type="file"
                            style="cursor: pointer"
                            accept="application/pdf"
                            :title="lang.P1025"
                            @change="onBriefingAttachmentFileChange"
                          />
                          <div class="input-group">
                            <label style="padding-top: 12px">{{
                              lang.P1026
                            }}</label>
                            <span class="input-group-btn input-group-sm">
                              <button
                                type="button"
                                class="btn btn-fab btn-fab-mini"
                              >
                                <i class="material-icons">attach_file</i>
                              </button>
                            </span>
                          </div>
                        </div>
                      </div>
                      <table
                        class="table table-striped table-hover"
                        style="margin: 0px"
                      >
                        <thead>
                          <tr>
                            <th style="width: 60%" class="text-center">
                              {{ lang.P1029 }}
                            </th>
                            <th style="width: 20%" class="text-center">
                              {{ lang.P1030 }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(briefing, index) in briefings"
                            :key="index"
                          >
                            <td>{{ briefing.FileName }}</td>
                            <td class="nopadding">
                              <div style="float: none">
                                <button
                                  type="button"
                                  class="btn"
                                  style="padding: 0px; margin: 7px"
                                  @click="
                                    globals.downloadFile(briefing.DownloadId)
                                  "
                                  :title="lang.P1027"
                                  :disabled="!briefing.DownloadId"
                                >
                                  <i class="material-icons text-green"
                                    >file_download</i
                                  >
                                </button>
                                <button
                                  type="button"
                                  class="btn"
                                  style="padding: 0px; margin: 7px"
                                  @click="
                                    removeAttachmentFile(briefings, index)
                                  "
                                  :title="lang.P1028"
                                  :disabled="!briefing.DownloadId"
                                >
                                  <i class="material-icons text-red">clear</i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <!-- surveys -->
                    <div class="col-md-6">
                      <div class="form-group form-group-files">
                        <label
                          for="inputSurveyAttachmentFile"
                          class="col-md-2 control-label"
                          >{{ lang.P1031 }}</label
                        >
                        <div class="col-md-8">
                          <input
                            id="inputSurveyAttachmentFile"
                            class="form-control"
                            type="file"
                            style="cursor: pointer"
                            accept="application/pdf"
                            :title="lang.P1032"
                            @change="onSurveyAttachmentFileChange"
                          />
                          <div class="input-group">
                            <label style="padding-top: 12px">{{
                              lang.P1033
                            }}</label>
                            <span class="input-group-btn input-group-sm">
                              <button
                                type="button"
                                class="btn btn-fab btn-fab-mini"
                              >
                                <i class="material-icons">attach_file</i>
                              </button>
                            </span>
                          </div>
                        </div>
                      </div>
                      <table
                        class="table table-striped table-hover"
                        style="margin: 0px"
                      >
                        <thead>
                          <tr>
                            <th style="width: 60%" class="text-center">
                              {{ lang.P1029 }}
                            </th>
                            <th style="width: 20%" class="text-center">
                              {{ lang.P1030 }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(survey, index) in surveys" :key="index">
                            <td>{{ survey.FileName }}</td>
                            <td class="nopadding">
                              <div style="float: none">
                                <button
                                  type="button"
                                  class="btn"
                                  style="padding: 0px; margin: 7px"
                                  @click="
                                    globals.downloadFile(survey.DownloadId)
                                  "
                                  :title="lang.P1034"
                                  :disabled="!survey.DownloadId"
                                >
                                  <i class="material-icons text-green"
                                    >file_download</i
                                  >
                                </button>
                                <button
                                  type="button"
                                  class="btn"
                                  style="padding: 0px; margin: 7px"
                                  @click="removeAttachmentFile(surveys, index)"
                                  :title="lang.P1035"
                                  :disabled="!survey.DownloadId"
                                >
                                  <i class="material-icons text-red">clear</i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <!-- Accordion entry 4 -->
                <div
                  class="panel-heading"
                  role="button"
                  id="headingEditProjectResponsibility"
                  data-toggle="collapse"
                  data-parent="#accordionEditProject"
                  href="#collapseEditProjectResponsibility"
                  aria-expanded="false"
                  aria-controls="collapseEditProjectResponsibility"
                >
                  <h4 class="panel-title">
                    <a class="collapsed">{{ lang.P1037 }}</a>
                  </h4>
                </div>
                <div
                  id="collapseEditProjectResponsibility"
                  class="panel-collapse collapse"
                  role="tabpanel"
                  aria-labelledby="headingEditProjectResponsibility"
                >
                  <div class="panel-body">
                    <table class="table table-hover">
                      <thead>
                        <tr>
                          <th
                            id="departmentUsersNameTableHeader"
                            class="col-md-8"
                          >
                            {{ lang.P1038 }}
                            <div
                              id="departmentUsersFilterStringInputContainer"
                              class="form-group"
                            >
                              <input
                                type="text"
                                class="form-control nopadding"
                                maxlength="50"
                                v-model="departmentUsersFilterString"
                                :placeholder="lang.P1039"
                              />
                            </div>
                          </th>
                          <th class="col-md-4">{{ lang.P1040 }}</th>
                        </tr>
                      </thead>

                      <tbody class="table-scrollbar text-left">
                        <template v-for="department in filteredDepartmentUsers">
                          <tr
                            class="tr-department"
                            :key="department.DepartmentId"
                          >
                            <td colspan="2">
                              <span>{{ department.DepartmentName }}</span>
                            </td>
                          </tr>
                          <tr
                            v-for="emp in department.Employees"
                            :key="emp.UserId"
                          >
                            <td style="padding: 7px">
                              <label
                                role="button"
                                class="text-black nopadding"
                                :for="`cb_empResponsible_${emp.UserId}`"
                                >{{ emp.DisplayName }}</label
                              >
                            </td>
                            <td
                              style="
                                padding: 5px;
                                padding-left: 10px;
                                overflow: hidden;
                              "
                            >
                              <div class="checkbox" style="margin: 0px">
                                <label>
                                  <input
                                    type="checkbox"
                                    :id="`cb_empResponsible_${emp.UserId}`"
                                    :checked="isEmployeeResponsible(emp.UserId)"
                                    @change="
                                      toggleEmployeeResponsibility(emp.UserId)
                                    "
                                  />
                                  <span class="checkbox-material">
                                    <span class="check"></span>
                                  </span>
                                </label>
                              </div>
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- Accordion entry 5 -->
                <div
                  class="panel-heading"
                  role="button"
                  id="headingEditProjectPlanning"
                  data-toggle="collapse"
                  data-parent="#accordionEditProject"
                  href="#collapseEditProjectPlanning"
                  aria-expanded="false"
                  aria-controls="collapseEditProjectPlanning"
                >
                  <h4 class="panel-title">
                    <a class="collapsed">{{ lang.P1008 }}</a>
                    <div v-show="isGanttVisible" id="zoomButtonBar">
                      <a
                        role="button"
                        title="Zoom out"
                        class="btn text-primary nopadding"
                        @click.stop="zoomGanttChart(false)"
                        :disabled="currentScaleUnit == 'year'"
                      >
                        <i class="material-icons md-36">remove</i>
                      </a>
                      <a
                        role="button"
                        title="Zoom in"
                        class="btn text-primary nopadding"
                        @click.stop="zoomGanttChart(true)"
                        :disabled="currentScaleUnit == 'week'"
                      >
                        <i class="material-icons md-36">add</i>
                      </a>
                    </div>
                  </h4>
                </div>
                <div
                  id="collapseEditProjectPlanning"
                  class="panel-collapse collapse"
                  role="tabpanel"
                  aria-labelledby="headingEditProjectPlanning"
                >
                  <div class="panel-body" style="padding: 15px">
                    <!-- Add inputs here -->
                    <div class="container gantt-container">
                      <gantt
                        ref="pmGantt"
                        id="pmGantt"
                        class="left-container"
                        :tasks="projectData.Gantt"
                        @task-updated="updateGanttTask"
                      ></gantt>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <b-alert
              variant="danger"
              dismissible
              :show="showAlert"
              @dismissed="showAlert = false"
              >{{ lang.P1009 }}</b-alert
            >
          </div>
          <div class="modal-footer">
            <!-- Add modal buttons here -->
            <button
              type="button"
              class="btn btn-raised btn-default"
              data-dismiss="modal"
            >
              {{ lang.P1010 }}
            </button>
            <button
              id="project-management-edit-modal-save-button"
              type="button"
              class="btn btn-raised dialog-btn-primary"
              @click="validateBeforeSubmit('editProjectDialog')"
              :disabled="
                !globals.isAccessAllowed('LoopOp_Projects_Update') &&
                !dialogModeAdd
              "
            >
              {{ lang.P1011 }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectManagementGantt from "./ProjectManagementGantt";
import Select2 from "../Tools/Select2";

const uuidv4 = require("uuid/v4");

// Returns the current date with an offset of days
var getCurrentDate = (days) => {
  var cdate = new Date();
  cdate.setDate(cdate.getDate() + days);
  cdate.setHours(0, 0, 0, 0);
  return cdate;
};

export default {
  name: "ProjectManagementEditModal",
  components: { gantt: ProjectManagementGantt, Select2 },
  props: [
    "selectedProject",
    "clientList",
    "surveyList",
    "showDialog",
    "dialogModeAdd",
  ],
  data() {
    // Global data inside the component is stored here
    return {
      dialogTitle: "", // Title of the dialog
      projectData: {
        Gantt: {
          data: [
            {
              id: uuidv4(),
              text: "",
              type: gantt.config.types.project,
              start_date: getCurrentDate(0),
              end_date: getCurrentDate(0),
            },
          ],
        },
      }, // The project data of the selected project is stored here
      showAlert: false, // true --> Alert for validation errors is visible
      invalidInputIds: [], // IDs of inputs with validation error
      isGanttVisible: false,
      currentScaleUnit: "week",
      selectedAssignedSurveyIds: [],
      selectedUnassignedSurveyIds: [],
      availableSurveys: [],
      fpProjectSince: null,
      fpProjectUntil: null,
      listOfProjectAccountables: {},
      briefings: [],
      surveys: [],
      importerList: [],
      departmentUsers: [],
      departmentUsersFilterString: "",
      lang: {
        P1000: "General",
        P1001: "Name",
        P1002: "This is a required entry!",
        P1003: "Client",
        P1004: "Please select...",
        P1005: "Surveys",
        P1006: "Available surveys",
        P1007: "Allocated surveys",
        P1008: "Project planning",
        P1009:
          "Your inputs are incorrect. Please check all fields marked in red!",
        P1010: "Cancel",
        P1011: "Save",
        P1012: "Create project",
        P1013: "Edit project",
        P1014: "Reporting visibility",
        P1015: "Start date",
        P1016: "End date",
        P1017: "Yes",
        P1018: "No",
        P1019: "Change Reporting Visibility",
        P1020:
          "Do you really want to make the whole survey visible in reporting?",
        P1021:
          "All defined security settings on user level for this survey will be lost.",
        P1022: "Project accountable",
        P1023: "File Upload",
        P1024: "Briefing",
        P1025: "Choose briefing",
        P1026: "Please choose a briefing...",
        P1027: "Download briefing",
        P1028: "Delete briefing",
        P1029: "File name",
        P1030: "Actions",
        P1031: "Survey",
        P1032: "Choose survey",
        P1033: "Please choose a survey...",
        P1034: "Download survey",
        P1035: "Delete survey",
        P1036: "Importer",
        P1037: "Responsibility",
        P1038: "Name",
        P1039: "Filter",
        P1040: "Responsible",
        P1041: "Show project history",
      },
    };
  },
  computed: {
    filteredDepartmentUsers() {
      let result = [];
      _.forEach(this.departmentUsers, (dep) => {
        if (!dep.Employees) return;
        if (!this.departmentUsersFilterString) {
          result.push(dep);
          return;
        }

        let filteredEmployees = _.filter(
          dep.Employees,
          (emp) =>
            emp.DisplayName.toLowerCase().indexOf(
              this.departmentUsersFilterString.toLowerCase()
            ) > -1
        );
        if (filteredEmployees[0]) {
          let resEntry = _.cloneDeep(dep);
          resEntry.Employees = filteredEmployees;
          result.push(resEntry);
        }
      });
      return result;
    },
  },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    this.getProjectAccountables();
    if (!this.globals.getDepartmentUsers)
      this.globals.getDepartmentUsers((callbackData) => {
        this.departmentUsers = callbackData;
      });
    if (this.feature.isAudiTarget && this.feature.isEnabled("audi_importers")) {
      this.globals.getImporterList((data) => {
        this.importerList = data;
      });
    }

    $("#editProjectDialog").on("hidden.bs.modal", (e) => {
      this.$emit("dialogClosed");
    });

    $("#editProjectDialog").on("shown.bs.modal", () => {
      gantt.render();
    });

    $("#collapseEditProjectPlanning").on("show.bs.collapse", () => {
      $("#editProjectDialog .modal-dialog").css("width", "95vw");
      this.isGanttVisible = true;
    });
    $("#collapseEditProjectPlanning").on("hide.bs.collapse", () => {
      $("#editProjectDialog .modal-dialog").css("width", "1200px");
      this.isGanttVisible = false;
    });

    $("#collapseEditProjectPlanning").on("shown.bs.collapse", () => {
      gantt.render();
    });

    // Initialize flatpickr instances
    this.fpProjectSince = flatpickr(
      "#inputProjectSince",
      this.globals.flatpickrDateConfig
    );
    this.fpProjectUntil = flatpickr(
      "#inputProjectUntil",
      this.globals.flatpickrDateConfig
    );
  },
  destroyed() {
    if (this.fpProjectSince) this.fpProjectSince.destroy();
    if (this.fpProjectUntil) this.fpProjectUntil.destroy();
  },
  methods: {
    // Validates an input with the given id, changes the input color depending on the validation result and returns the result
    validateInput(id) {
      var result = $("#" + id)[0].checkValidity(); // Checks validation depending on the input type or a given pattern in the template
      if (result) {
        $("#" + id)
          .parent()
          .parent()
          .removeClass("has-error"); // has-error has to be added to the form-group element
        var idx = this.invalidInputIds.indexOf(id);
        if (idx > -1) {
          this.invalidInputIds.splice(idx, 1); // Remove from list, if valid
        }
      } else {
        $("#" + id)
          .parent()
          .parent()
          .addClass("has-error");
        if (this.invalidInputIds.indexOf(id) < 0) this.invalidInputIds.push(id); // Add to list, if invalid
      }
      return result;
    },

    // Returns true if an input has a validation error, otherwise false
    inputHasError(id) {
      if (this.invalidInputIds.indexOf(id) > -1) return true;
      return false;
    },

    // Triggers input validation and ensures further progress if validation was successful
    validateBeforeSubmit(dialogId) {
      var result = true;

      var elements = $("#" + dialogId).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0)
          result = this.validateInput(elements[i].id) && result; // If only one input is invalid, the whole form is invalid
      }

      if (dialogId == "editProjectDialog") {
        this.showAlert = !result;
        if (!result) return;
        this.saveEditProjectDialogData();
      }
    },

    // Resets all validation errors for the given dialog
    resetValidationErrors(dialogId) {
      var elements = $("#" + dialogId).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0)
          $("#" + elements[i].id)
            .parent()
            .parent()
            .removeClass("has-error");
      }
      this.invalidInputIds = [];
    },

    showProjectHistory() {
      let config = {
        type: "Project",
        guid: this.projectData.ProjectGuid,
        id: this.projectData.ProjectId,
      };
      this.globals.$emit("showElementHistory", config);
    },

    zoomGanttChart(zoomIn) {
      var currentUnit = gantt.config.scale_unit;
      var newUnit = "";

      switch (currentUnit) {
        case "week":
          newUnit = zoomIn ? "week" : "month";
          break;
        case "month":
          newUnit = zoomIn ? "week" : "year";
          break;
        case "year":
          newUnit = zoomIn ? "month" : "year";
          break;
        default:
          newUnit = "week";
      }

      switch (newUnit) {
        case "week":
          gantt.config.date_scale = "%F, %Y, W%W";
          gantt.config.subscales = [{ unit: "day", step: 1, date: "%j, %D" }];
          break;
        case "month":
          gantt.config.date_scale = "%M %Y";
          gantt.config.subscales = [{ unit: "week", step: 1, date: "W%W" }];
          break;
        case "year":
          gantt.config.date_scale = "%Y";
          gantt.config.subscales = [{ unit: "month", step: 1, date: "%M" }];
          break;
        default:
          gantt.config.date_scale = "%F, %Y, W%W";
          gantt.config.subscales = [{ unit: "day", step: 1, date: "%j, %D" }];
      }

      gantt.config.scale_unit = newUnit;
      this.currentScaleUnit = newUnit;
      gantt.render();
    },

    // Stores all surveys that are available for the selected client to a list and removes all selected surveys, if necessary
    filterSurveysForClient(cid, removeSelectedSurveys) {
      cid = parseInt(cid);
      if (cid > -1) {
        var listObj = this.surveyList.filter((s) => {
          return s.ClientId == cid;
        });
        this.availableSurveys = listObj.length == 0 ? [] : listObj[0].Surveys;
      } else this.availableSurveys = [];

      this.selectedAssignedSurveyIds = [];
      this.selectedUnassignedSurveyIds = [];

      if (removeSelectedSurveys) this.projectData.Surveys = [];
    },

    getAvailableSurveysForClient() {
      let request = `api/Clients/${this.projectData.ClientId}/AvailableSurveys`;
      this.projectData.AvailableSurveys = [];
      $.ajax({
        method: "GET",
        url: request,
        success: (data) => {
          if (data && data.AvailableSurveys) {
            this.projectData.AvailableSurveys = data.AvailableSurveys;
            this.filterSurveysForClient(this.projectData.ClientId, false);
          }
          this.filterSurveysForClient(this.projectData.ClientId, false);
        },
        error: () => {
          console.error(
            "Survey data access failed in getAvailableSurveysForClient()"
          );
          this.globals.showErrorSnackbar("Survey data access failed");
        },
      });
    },

    // Shows a security modal for changing reporting visibility to avoid data loss
    surveyReportingVisibilityChanged(survey) {
      if (survey.ReportingVisibility === false) return;
      let forceReportingVisibilityChange = false;

      this.globals.$off("SurveyReportingVisibilityChangedModalYesConfirmation");
      this.globals.$on(
        "SurveyReportingVisibilityChangedModalYesConfirmation",
        () => {
          survey.ReportingVisibility = true;
          forceReportingVisibilityChange = true;
        }
      );
      this.globals.$off("SurveyReportingVisibilityChangedModalDialogClosed");
      this.globals.$on(
        "SurveyReportingVisibilityChangedModalDialogClosed",
        () => {
          if (!forceReportingVisibilityChange)
            survey.ReportingVisibility = false;
          forceReportingVisibilityChange = false;
        }
      );

      this.globals.$emit("openGlobalConfirmationDialog", {
        initiator: "SurveyReportingVisibilityChangedModal",
        confirmationTitle: this.lang.P1019,
        colorRed: true,
        yesButtonText: this.lang.P1017,
        noButtonText: this.lang.P1018,
        htmlText: `<p><b>${this.lang.P1020}</b></p>
          <p>${this.lang.P1021}</p>`,
      });
    },

    // Assigns selected surveys to the project
    assignSurveys() {
      if (this.selectedUnassignedSurveyIds.length === 0) return;
      for (var i = 0; i < this.selectedUnassignedSurveyIds.length; i++) {
        this.projectData.Surveys.push({
          SurveyId: this.selectedUnassignedSurveyIds[i],
          ReportingVisibility: true,
        });
      }
      this.selectedUnassignedSurveyIds = [];
    },

    // Unassigns selected surveys from the project
    unassignSurveys() {
      if (this.selectedAssignedSurveyIds.length === 0) return;
      for (var i = 0; i < this.selectedAssignedSurveyIds.length; i++) {
        let index = this.getIndexOfSurveyInProjectDataSurveys(
          this.selectedAssignedSurveyIds[i]
        );
        this.projectData.Surveys.splice(index, 1);
        this.projectData.AvailableSurveys.push(
          this.selectedAssignedSurveyIds[i]
        );
      }
      this.selectedAssignedSurveyIds = [];
    },

    // Returns a list of currently assigned surveys
    getAssignedSurveys() {
      let assignedSurveys = this.availableSurveys.filter((s) => {
        return (
          _.findIndex(this.projectData.Surveys, (ps) => {
            return s.SurveyId === ps.SurveyId;
          }) > -1
        );
      });
      return assignedSurveys;
    },

    // Returns a list of currently unassigned surveys
    getUnassignedSurveys() {
      let unassignedSurveys = this.availableSurveys.filter((s) => {
        return (
          _.findIndex(this.projectData.Surveys, (ps) => {
            return s.SurveyId === ps.SurveyId;
          }) < 0 &&
          _.findIndex(this.projectData.AvailableSurveys, (pas) => {
            return s.SurveyId === pas;
          }) > -1
        );
      });
      return unassignedSurveys;
    },

    // Adds a new item to the survey list if it's not already in the list. Otherwise the item will me removed from the list.
    toggleListItem(list, id) {
      var index = list.indexOf(id);
      if (index > -1) {
        list.splice(index, 1);
      } else list.push(id);
    },

    // Adds a new item to the survey list if it's not already in the list. Otherwise the item will me removed from the list.
    toggleSurveyListItem(list, id) {
      let index = _.findIndex(list, (s) => {
        return s.SurveyId === id;
      });

      if (index > -1) {
        list.splice(index, 1);
      } else list.push({ SurveyId: id, ReportingVisibility: true });
    },

    // Returns the index of a survey in the list of surveys that are attached to the project
    getIndexOfSurveyInProjectDataSurveys(id) {
      return _.findIndex(this.projectData.Surveys, (s) => {
        return s.SurveyId === id;
      });
    },

    // Fills the editProject dialog with data, depending on the dialog mode.
    openEditProjectDialog() {
      this.departmentUsersFilterString = "";

      if (this.dialogModeAdd) {
        this.dialogTitle = this.lang.P1012;
        delete this.projectData.ProjectId;
        delete this.projectData.ProjectGuid;
        delete this.projectData.ProjectCreatedBy;
        delete this.projectData.ProjectName;
        delete this.projectData.ClientId;
        delete this.projectData.ImporterGuid;
        delete this.projectData.ProjectSince;
        delete this.projectData.ProjectUntil;
        delete this.projectData.ProjectActiveLocationsCount;
        delete this.projectData.ProjectTotalLocationsCount;
        delete this.projectData.ProjectSurveysCount;
        delete this.projectData.ProjectAccountableGuid;
        delete this.projectData.ProjectEmployees;

        if (
          this.feature.isAudiTarget &&
          this.feature.isEnabled("audi_importers") &&
          this.clientList[0]
        ) {
          this.projectData.ClientId = this.clientList[0].ClientId;
          this.getAvailableSurveysForClient();
        }

        this.fpProjectUntil.clear();
        this.fpProjectSince.clear();

        this.briefings = [];
        this.surveys = [];

        this.filterSurveysForClient(-1, true);
        this.initGanttProject();
        $("#editProjectDialog").modal("show");
      } else {
        this.dialogTitle = this.lang.P1013;

        $.ajax({
          method: "GET",
          url: `api/Projects/${this.selectedProject}`,
          success: (data) => {
            if (data.Importers) {
              data.ImporterGuid = data.Importers[0].ImporterGuid;
              delete data.Importers;
            }
            this.projectData = data; // Store response data from server
            if (this.projectData.ClientId)
              this.filterSurveysForClient(data.ClientId, false);
            if (!this.projectData.Surveys) this.projectData.Surveys = [];

            if (this.projectData.ProjectSince)
              this.fpProjectSince.setDate(this.projectData.ProjectSince);
            else this.fpProjectSince.clear();
            if (this.projectData.ProjectUntil)
              this.fpProjectUntil.setDate(this.projectData.ProjectUntil);
            else this.fpProjectUntil.clear();

            if (this.projectData.Attachments) {
              this.briefings = this.projectData.Attachments.filter(
                (attachment) => attachment.AttachmentType === "Briefing"
              );
              this.surveys = this.projectData.Attachments.filter(
                (attachment) => attachment.AttachmentType === "Survey"
              );
            }

            gantt.clearAll();
            if (
              this.projectData.ProjectSince &&
              this.projectData.ProjectUntil
            ) {
              gantt.parse(this.projectData.Gantt);
              this.prepareGanttChart();
            } else this.initGanttProject();
            $("#editProjectDialog").modal("show");
          },
          error: () => {
            console.error(
              "Project data access failed in openEditProjectDialog()"
            );
            this.globals.showErrorSnackbar("Project data access failed");
            this.$emit("dialogClosed");
          },
        });
      }
      this.showAlert = false;
      this.resetValidationErrors("editProjectDialog");
    },

    // Closes the editProjectDialog
    closeEditProjectDialog() {
      $("#editProjectDialog").modal("hide");
    },

    // Opens all tasks in the current gantt dataset and sets the initial zoom depending on the project duration
    prepareGanttChart() {
      var gData = this.projectData.Gantt.data;
      for (var i = 0; i < gData.length; i++) {
        if (
          gData[i].type != gantt.config.types.scenario &&
          gantt.hasChild(gData[i].id)
        ) {
          gantt.open(gData[i].id);
        }
      }

      var duration =
        (gData[0].end_date - gData[0].start_date) / (1000 * 60 * 60 * 24); // duration in days

      if (duration > 120) {
        gantt.config.scale_unit = "year";
        gantt.config.date_scale = "%Y";
        gantt.config.subscales = [{ unit: "month", step: 1, date: "%M" }];
      } else if (duration > 30) {
        gantt.config.scale_unit = "month";
        gantt.config.date_scale = "%M %Y";
        gantt.config.subscales = [{ unit: "week", step: 1, date: "W%W" }];
      } else {
        gantt.config.scale_unit = "week";
        gantt.config.date_scale = "%F, %Y, W%W";
        gantt.config.subscales = [{ unit: "day", step: 1, date: "%j, %D" }];
      }
    },

    // Sends the data from editProject dialog to the server to store it in the database
    saveEditProjectDialogData() {
      if (this.briefings.length > 0 || this.surveys.length > 0)
        this.projectData.Attachments = this.briefings.concat(this.surveys);
      else delete this.projectData.Attachments;
      let sendData = _.cloneDeep(this.projectData);
      delete sendData.Gantt;

      if (sendData.ImporterGuid) {
        sendData.Importers = [{ ImporterGuid: sendData.ImporterGuid }];
        delete sendData.ImporterGuid;
      }

      if (this.dialogModeAdd) {
        // Create new project
        $.ajax({
          method: "POST",
          url: "api/Projects",
          data: JSON.stringify(sendData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: (data) => {
            // If POST was successful, refresh displayed data and hide dialog
            this.globals.showSuccessSnackbar("Project creation successful");
            this.closeEditProjectDialog();
            // this.$emit("dialogDataSaved", data.ProjectId, sendData.ClientId);
            this.$emit("dialogDataSaved", data);
          },
          error: () => {
            console.error("Error on POST in saveEditProjectDialogData()");
            this.globals.showErrorSnackbar("Project creation failed");
          },
        });
      } else {
        // Update existing project
        $.ajax({
          method: "PUT",
          url: "api/Projects/" + this.projectData.ProjectId,
          data: JSON.stringify(sendData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: (data) => {
            if (data && data.length > 0 && data[0].error) {
              console.error("Error on PUT in saveEditProjectDialogData()");
              this.globals.showErrorSnackbar(data[0].error);
              return;
            }
            // If PUT was successful, refresh displayed data and hide dialog
            this.globals.showSuccessSnackbar("Project update successful");
            this.closeEditProjectDialog();
            this.$emit(
              "dialogDataSaved",
              sendData.ProjectId,
              sendData.ClientId
            );
          },
          error: () => {
            console.error("Error on PUT in saveEditProjectDialogData()");
            this.globals.showErrorSnackbar("Project update failed");
          },
        });
      }
    },

    // Updates the task data after a task was updated
    updateGanttTask(id, action, task) {
      if (action == "inserted") {
        this.projectData.Gantt.data.push(task);
      } else if (action == "updated") {
        var idx = this.projectData.Gantt.data
          .map((t) => {
            return t.id;
          })
          .indexOf(id);
        this.projectData.Gantt.data[idx] = task;
      } else if (action == "deleted") {
        this.projectData.Gantt.data = this.projectData.Gantt.data.filter(
          (t) => {
            return t.id != id;
          }
        );
      } else console.error("Error on task update in updateGanttTask()");
    },

    // Initializes the gantt project data
    initGanttProject() {
      var projectTemplate = {
        id: uuidv4(),
        text: "",
        type: gantt.config.types.project,
        start_date: getCurrentDate(0),
        end_date: getCurrentDate(1),
      };

      projectTemplate.start_date.setHours(0, 0, 0, 0);
      projectTemplate.end_date.setHours(0, 0, 0, 0);

      this.projectData.Gantt.data = [projectTemplate];

      gantt.clearAll();
      gantt.parse(this.projectData.Gantt);
      this.prepareGanttChart();
    },
    getProjectAccountables() {
      let queryString = "/api/data/ProjectAccountable";
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          if (!_.isEmpty(data)) this.listOfProjectAccountables = data;
        },
        error: () => {
          console.error(
            "Project accountables data access failed in getProjectAccountables()"
          );
          this.globals.showErrorSnackbar(
            "Project accountables data access failed"
          );
        },
      });
    },
    onBriefingAttachmentFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length || !files[0].name) return;

      let attachmentFileObject = files[0];

      let uploadSuccess = (data) => {
        this.briefings.push({
          DownloadId: data[0].DownloadId,
          FileName: attachmentFileObject.name,
          AttachmentType: "Briefing",
        });

        this.globals.showSuccessSnackbar("Attachment upload successful");
        this.$forceUpdate();
      };
      this.globals.uploadFile(attachmentFileObject, false, uploadSuccess);
      e.target.value = null;
    },
    onSurveyAttachmentFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length || !files[0].name) return;

      let attachmentFileObject = files[0];

      let uploadSuccess = (data) => {
        this.surveys.push({
          DownloadId: data[0].DownloadId,
          FileName: attachmentFileObject.name,
          AttachmentType: "Survey",
        });

        this.globals.showSuccessSnackbar("Attachment upload successful");
        this.$forceUpdate();
      };
      this.globals.uploadFile(attachmentFileObject, false, uploadSuccess);
      e.target.value = null;
    },
    removeAttachmentFile(list, fileIndex) {
      list.splice(fileIndex, 1);
      this.$forceUpdate();
    },
    isEmployeeResponsible(userId) {
      if (
        !this.projectData.ProjectEmployees ||
        !this.projectData.ProjectEmployees[0]
      )
        return false;
      return (
        _.findIndex(
          this.projectData.ProjectEmployees,
          (emp) => emp.UserId == userId
        ) > -1
      );
    },
    toggleEmployeeResponsibility(userId) {
      if (!this.projectData.ProjectEmployees)
        this.projectData.ProjectEmployees = [];

      if (!this.isEmployeeResponsible(userId))
        this.projectData.ProjectEmployees.push({
          UserId: userId,
        });
      else
        _.remove(
          this.projectData.ProjectEmployees,
          (emp) => emp.UserId === userId
        );

      this.$forceUpdate();
    },
  },
  watch: {
    showDialog() {
      if (
        this.showDialog &&
        (this.dialogModeAdd ||
          this.globals.isAccessAllowed("LoopOp_Projects_Read"))
      ) {
        this.openEditProjectDialog();
      } else {
        this.closeEditProjectDialog();
        this.$emit("dialogClosed");
      }
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
};
</script>

<style scoped>
/* #collapseEditProjectSurveys table {
  width: 100%;
}
#collapseEditProjectSurveys tbody {
  height: calc(100vh - 440px);
  overflow-y: auto;
}
#collapseEditProjectSurveys tbody,
#collapseEditProjectSurveys tbody td,
#collapseEditProjectSurveys tbody > tr {
  display: block;
} */

#pmGantt {
  min-height: 300px;
  width: 100%;
  padding: 0;
}
.gantt-container {
  padding: 0 5px;
  margin: 0;
  width: 100%;
}

#editProjectDialog .modal-dialog {
  width: 1200px;
  transition: all 200ms ease;
}

#headingEditProjectPlanning > h4 {
  position: relative;
}
#zoomButtonBar {
  position: absolute;
  right: -5px;
  display: inline-flex;
  top: -10px;
}

.form-group-files {
  padding: 2px 0;
  overflow: hidden;
}

#collapseEditProjectResponsibility > .panel-body {
  padding: 0 !important;
  margin: 15px;
  max-height: calc(100vh - 440px);
  overflow: auto;
  border: 2px solid #ddd;
}
#collapseEditProjectResponsibility .table thead th {
  position: sticky;
  top: 0;
  background-color: #fff;
  box-shadow: inset 0 0 #ddd, 0 1px #ddd;
  z-index: 2;
}
#collapseEditProjectResponsibility .tr-department {
  background-color: var(--color-panel-heading);
  font-weight: bold;
}
#collapseEditProjectResponsibility .tr-department:hover {
  opacity: 0.7;
}

#departmentUsersNameTableHeader {
  padding-top: 0;
  padding-bottom: 0;
}

#departmentUsersFilterStringInputContainer {
  display: inline;
  padding-left: 40px;
}
#departmentUsersFilterStringInputContainer > .form-control {
  display: inline;
  max-width: 200px;
  font-weight: 500;
}
#showProjectHistoryInfoIcon {
  position: relative;
  left: 10px;
  margin: -5px;
  vertical-align: middle;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// ProjectManagementEditModal.vue?5ccebd27